import React from 'react';
import "../Components/CSS/Problem.css"
import { Link } from 'react-router-dom';

import { useContext } from 'react';
import {userContext} from '../App';

import { v4 as uuidv4 } from 'uuid';
import ReactTooltip from 'react-tooltip';

const colorMapping = {
  "EASY": "#76E744",
  "MEDIUM": "#51ADEF",
  "HARD": "red",
}
const inActiveStyle = {listStyle: "none", textDecoration: "none", color: "#02203C"}

const Problem = ({problem}) => {

  const {user, setUser} = useContext(userContext);
  let link = `/content/${problem.id}`;

  const id = uuidv4()

  let tooltipText = ""
  if(problem.tier === "P" && user.tier === "F") {
    tooltipText = "(Please pay to unlock this question)"
    link = "#"
  }

  function paidProblemReturn() {
    return (
      <>
        <div className='problem paid' data-tip="Payment Required" data-for={id}>
          <Link to={user.tier === "P" ? link : '/purchase' } style={inActiveStyle}>
              <p className='link-paragraph'>{problem.name}</p>
            </Link>
            <span style={{backgroundColor: colorMapping[problem.difficulty]}}></span>
        </div>
        {user.tier === "F" ? <ReactTooltip id={id} place="top" type='error' effect='solid' />: <></>}
      </>
    )
  }

  function freeProblemReturn() {
    return (
      <div className='problem'>
          <Link to={link} style={inActiveStyle}>
              <p className='link-paragraph'>{problem.name}</p>
          </Link>
          <div style={{height: '100%', display: 'flex', alignItems: 'center'}}>
            <img src="free.png" alt="" style={{height: '40px', marginRight: '20px'}}/>
            <p style={{backgroundColor: colorMapping[problem.difficulty], width: '40px', height: 'inherit', marginTop: '0px', marginBottom: '0px'}}></p>
          </div>
      </div>
    )
  }

  return (
      <>
        {problem.tier === "F" ? freeProblemReturn(): paidProblemReturn()}
      </>
  )
};

export default Problem;
